import { Component, ElementRef, EnvironmentInjector, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormControl, UntypedFormGroup, UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { FreshAuthService } from '../fresh-auth.services';
import { NgbModal, NgbModalRef, } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddCustomerService } from '../../admin/add-customer.service';
import { ViewSanctionService } from './view-ntb.service';
import { environment as ENV } from '../../../environments/environment';
import { BaseApi } from '../../laas/base-api.service';
import { AdminService } from '../../admin/admin.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
// import { environment } from '../../../environments/environment.ubi';
import { HttpClient, HttpParams } from "@angular/common/http";
import { saveAs } from "file-saver/dist/FileSaver";
import FileSaver from "file-saver";
import { OpenDialogYesOrNo } from '../dialog-yes-or-no/dialog-yes-or-no.component';
import { forkJoin, Observable } from 'rxjs';
import { ApplicantService } from 'app/laas/applicant.service';
import { AdvancedFilterService } from 'app/core/advanced-filter/advanced-filter.service';
import * as constants from '../../../app/constant';
@Component({
  selector: 'wl-view-ntb',
  providers: [ViewSanctionService, AdminService, AddCustomerService],
  templateUrl: './view-ntb.component.html',
  styleUrls: ['./view-ntb.component.scss'],
})
export class ViewNtbComponent implements OnInit {
  noUserFound: string;
  search = new UntypedFormControl();
  searchHolder: string;
  showSelectedDate: boolean;
  currentDate: String;
  selectedDate: any;
  modalReference: any;
  showCustDetailsPopup: boolean = false;
  totalCount: any;
  totalPage: number = 1;
  adminForm: UntypedFormGroup;
  iscredCount: any;
  showOrHide: boolean;

  display: boolean;
  allUsers: any = [];
  pageId = 1;
  selectedOption: string;
  page: number = 1;
  model: NgbDateStruct;
  date: { year: number; month: number };
  @ViewChild('date1') firstDate: ElementRef;
  @ViewChildren('custId') custIds: QueryList<ElementRef>;
  @ViewChild('editModal') editModal: TemplateRef<any>;
  @ViewChild('loanModal') loanModal: TemplateRef<any>;
  @ViewChild('confirmModal') confirmModal: TemplateRef<any>;
  @ViewChild('docModal') docModal: TemplateRef<any>;
  @ViewChild('downloadModal') downloadModal: TemplateRef<any>;
  ediTModaluser: any;
  kycModaluser: any;
  lienModaluser: any;
  docModalData: any = {};
  curDate = new Date();
  // customerId: any;
  updatedUser: any;
  isSanctionDataPresent: boolean = false;
  public sanctionForm: UntypedFormGroup;
  documentDate: any = new Date();
  documentDateString: any = new DatePipe('en-US').transform(this.documentDate, 'y-MM-dd');
  filterTableDate = new Date();
  formatFilterTableDate: any = new DatePipe('en-US').transform(this.filterTableDate, 'y-MM');
  downloadForms: any[];
  loading: boolean;
  limit: number = 10;
  offset: number = 0;
  showLoanCreatedPopup: boolean = false;
  showFinalPopup: boolean = false;
  kycModalRef: NgbModalRef;
  docModalRef: NgbModalRef;
  showKycConfirmPopup: boolean = false;
  showLienConfirmPopup: boolean = false;
  showDocExecutedPopup: boolean = false;
  downloadDocModalRef: NgbModalRef;
  modal2Ref: NgbModalRef;
  finalModalRef: NgbModalRef;
  roleId: number;
  kccNewUat: string = ENV.kccNewUat;
  kccNew_BRE_Checklist: string = ENV.kccNew_BRE_Checklist;
  demoDatePicker;
  subheading1: string;
  subheading2: string;
  maxDate: string;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: number;
  pointerStyle: object;
  enableViewsOnLogin: boolean = true;
  showNtbDataTable: boolean = true;
  filter: string = "";
  showModal: boolean;
  showDownloadModal: boolean;
  currentUser: any;
  checkBoxObj: any;
  checkBoxList: any;
  allUsersNew: any;
  showChecksColumn: boolean;
  showDownloadUploadColumn: boolean;
  isRJorGJ: boolean = false; // Rajasthan & Gujarat: Create Loan Account requires both KYC + LDE checkboxes

  applicantId: any;
  wantAccWiseBreDownloaded: boolean;
  showSanctionedDocuments: boolean;
  showAccwiseBreCheckBox: boolean = false;
  showDownloadDocsModal: boolean;
  lienCheckBoxCode: string = 'cropLienCreated';
  lienCheckBoxInfo: string = 'Creation / noting of Banks lien (Hypothecation) on the Standing / Proposed Crop is done as per the extant guidelines, wherever online charge creation facility is available.';

  constructor(
    // public activeModal: NgbActiveModal,
    public applicant: ApplicantService,
    private fb: UntypedFormBuilder,
    private _fb: UntypedFormBuilder,
    private freshAuthService: FreshAuthService,
    private customer: ViewSanctionService,
    private snackbar: MatSnackBar,
    private modalService: NgbModal,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    private baseapi: BaseApi,
    public dialog: MatDialog,
    private calendar: NgbCalendar,
    private api: BaseApi,
    private https: HttpClient,
    private advancedFilterService: AdvancedFilterService
  ) {
    // this below code will enable/disable the input/buttons based on login
    if (this.applicant.shouldIbeClicked()) {
      console.log('inside if--------->');
      //this.pointerStyle = {'pointer-events':'auto'}
      this.enableViewsOnLogin = true;
    } else {
      //this.pointerStyle = {'pointer-events':'none'}
      this.enableViewsOnLogin = false;
    }

    this.adminForm = this.fb.group({
      custId: ['', Validators.required],
      name: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-zA-Z ]+'),
          Validators.maxLength(10),
        ]),
      ],
      email: [''],
      mobileNo: [''],

      resAdd: [''],
      offAdd: [''],
      resUnitNo: [''],
      offUnitNo: [''],
      employeeName: [''],
      employeeId: [''],
    });


    this.iscredCount = ENV.creditScoreSetting.credCount;
    if (ENV.creditScoreSetting.credMenu == 'shfl') {
      this.showOrHide = false;
    } else {
      this.showOrHide = true;
    }

    this.searchHolder = 'Search Applicant by Name';

    this.display = false;
  }

  onSearchClick(event) {
    this.loading = true;
  }

  onSearch(value: string) {
    this.filter = value;
    if (this.isCoLogin()) {
      return this.applyFilter(this.filter, 0, 1, 1);
    }

    this.pageId = 1;
    this.page = 1;
    this.loading = true;
    this.customer.getUsers(value, 1, 0, 10).subscribe(
      (res) => {
        this.loading = false;

        if (res && res.success) {
          const resultData = res.result && res.result.resultData ? res.result.resultData : [];

          if (resultData.length === 0) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.noUserFound = null;
          }

          this.allUsers = [];
          this.page = 1;

          this.allUsers = resultData;
          this.setCheckBoxesStatuses(this.allUsers);
          this.formArr.clear();
          this.allUsers.forEach((user) => {
            this.formArr.push(this.initRows(user));
          });

          this.totalCount = res.result && res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        } else {
          this.noUserFound = 'Customer data not found';
          this.allUsers = [];
          this.allUsersNew = [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      },
      (err) => {
        this.totalCount = 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        this.loading = false;
        throw err;
      }
    );
  }

  ngOnInit() {
    this.roleId = +this.freshAuthService.getRoleId();
    if (this.isCoLogin()) {
      this.showNtbDataTable = false;
      this.showAccwiseBreCheckBox = true;
    }

    sessionStorage.removeItem('filterDateSanctionStart');
    sessionStorage.removeItem('filterDateSanctionEnd');
    this.maxDate = this.freshAuthService.getCurrentMonth();
    this.sanctionForm = this._fb.group({
      sanctionRows: this._fb.array([]),
    });

    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();

    !this.isCoLogin() && this.getData();

    if (sessionStorage.getItem('wEnlw3OeU3')) {
      this.getCheckBoxes();
    };
    this.showOrHideTableColumns();
  }

  setCheckBoxesStatuses(allUsers) {
    if (!this.checkBoxList) {
      return;
    }
    this.allUsersNew = allUsers.map((user, index) => {
      if (user && user.user_checklist_options) {
        const data = user.user_checklist_options;
        user.checkBoxList = [];

        for (let key in data) {
          if (data[key]) {
            const currentCheckBoxObj = this.checkBoxList.find(item => item.code === key);
            if (currentCheckBoxObj) {
              user.checkBoxList.push({
                ...currentCheckBoxObj,
                checked: false
              });
            }
          }
        }
        user.checkBoxesList = user.checkBoxList;
        // this.checkAndDisableAllCheckboxes(index)

      } else {
        user.checkBoxesList = this.checkBoxList.map((item) => ({
          ...item,
          checked: false
        }));
      }
      user.isAllChecked = this.isAllChecked(user.checkBoxesList);
      if (user.loanAccountNo) {
        user.loanAccountCreated = true;
      }
      console.log("loanAccountCreated", user.loanAccountCreated);
      return user;
    });

    this.allUsersNew.forEach((user, index) => {
      if (user.user_checklist_options) {
        this.checkAndDisableAllCheckboxes(index)
      }
    })

    console.log(this.allUsersNew);


  }

  isAllChecked(checkBoxesList): boolean {
    return checkBoxesList.every(item => item.checked);
  }

  toggleCheckbox(userIndex: number, checkboxIndex: number) {
    let user = this.allUsersNew[userIndex];
    user.checkBoxesList[checkboxIndex].checked = !user.checkBoxesList[checkboxIndex].checked;
    user.isAllChecked = this.isAllChecked(user.checkBoxesList);
  }

  submitCheckBoxes(user, i) {

    let check_box_list = [];
    user.checkBoxesList.forEach((obj) => {
      check_box_list.push(obj.code)
    })

    const payload = {
      applicantId: user.id,
      selectedOptions: check_box_list,
      adminId: sessionStorage.getItem('getuserId')
    }
    console.log(payload);

    this.freshAuthService.submitCheckboxes(payload).subscribe((resp) => {
      console.log(resp);
      if (resp && resp.status) {
        this.allUsersNew[i].isCheckBoxesSubmitted = true;
      }
    }, (err) => {
      this.snackbar.open("Failed to submit details", "OK", { duration: 3000 })
    })
  }

  checkAndDisableAllCheckboxes(userIndex: number) {

    if (this.allUsersNew) {
      let user = this.allUsersNew[userIndex];
      user.checkBoxesList.forEach(item => {
        item.checked = true;
        item.disabled = true;
      });
      user.isCheckBoxesSubmitted = true;
      user.isAllChecked = this.isAllChecked(user.checkBoxesList);
    }
  }


  getCheckBoxes() {
    this.freshAuthService.fetchUsersChecklistOptions().subscribe((resp) => {
      console.log(resp)
      if (resp && resp.message.toLowerCase() == "success") {
        let data = resp.data;
        this.checkBoxList = [];
        for (let key in data) {
          if (data[key].enabled) {
            this.checkBoxList.push({ code: key, ...data[key] })
          }
        }
        console.log(this.checkBoxList)
        if (this.allUsers && this.allUsers.length) {
          this.setCheckBoxesStatuses(this.allUsers);
        }
      }
    }, (err) => {
      this.snackbar.open("Failed to fetch checkbox list.", "OK")
    })
  }

  uploadPopup(user) {
    this.currentUser = user;
    this.showModal = true;
  }

  handleClose() {
    this.showModal = false;
  }

  handleCloseDownload() {
    this.showDownloadModal = false;
  }

  downloadPopup(user) {
    this.currentUser = user;
    this.showDownloadModal = true;
  }

  filesUploaded(event) {

  }

  initRows(user: any) {
    const custId: string = user.custId ? user.custId : '';
    const group = this._fb.group({
      customerId: [
        custId,
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(10),
          Validators.pattern('^[0-9]*$'),
        ],
      ],
    });

    if (user.loanAccountNumber || user.loanAccountNo) {
      group.get('customerId').disable();
    }

    return group;
  }
  get formArr() {
    return this.sanctionForm.get('sanctionRows') as UntypedFormArray;
  }
  getData() {
    this.loading = true;
    const admin_id = sessionStorage.getItem('wl-admin-id');
    const branch_code = sessionStorage.getItem('branch_code');
    const ro_code = sessionStorage.getItem('ro_code');
    const zonal_code = sessionStorage.getItem('zonal_code');

    this.freshAuthService
      .loanSanctioned(
        admin_id,
        branch_code,
        ro_code,
        zonal_code,
        0,
        10,
        1,
        '',
        'loan_sanctioned_ntb'
      )
      .subscribe(
        (res) => {
          console.log(res, 'abc');
          this.loading = false;
          if (res.result && res.result.resultData && res.result.resultData.length == 0) {
            this.noUserFound = 'No User found for query: ' + this.search.value;
          } else {
            this.noUserFound = null;
            this.allUsersNew = []
          }
          this.allUsers = res ? res.resultData : [];
          this.formArr.clear();
          this.allUsers.forEach((user) => {
            this.formArr.push(this.initRows(user));
            this.showFinalPopup = false;
          });
          this.setCheckBoxesStatuses(this.allUsers);
          this.totalCount = res && res.count ? res.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.isSanctionDataPresent = true;
        },
        (err) => {
          this.loading = false;
          this.allUsersNew = [];
          throw err;
        }
      );
  }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    if (this.isCoLogin()) {
      return this.applyFilter(input, offset, pageId, pageId);
    }

    const admin_id = sessionStorage.getItem('wl-admin-id');
    const branch_code = sessionStorage.getItem('branch_code');
    const ro_code = sessionStorage.getItem('ro_code');
    const zonal_code = sessionStorage.getItem('zonal_code');

    console.log(pageId);
    this.pageId = pageId;
    this.loading = true;

    console.log('before page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log('after page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);

    this.freshAuthService
      .loanSanctioned(
        admin_id,
        branch_code,
        ro_code,
        zonal_code,
        offset,
        limit,
        1,
        input,
        'loan_sanctioned_ntb'
      )
      .subscribe(
        (res) => {
          this.loading = false;
          console.log('result ' + JSON.stringify(res));
          this.allUsers = res.resultData ? res.resultData : '';
          this.setCheckBoxesStatuses(this.allUsers);
          this.totalCount = res && res.count ? res.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          console.log('this.totalPage ' + this.totalPage);
          // this.custId = res.result.custId;
          // console.log("custId " +  res.result.custId);
        },
        (err) => {
          this.loading = false;
          //this.allUsers = Observable[''];
          this.allUsersNew = []
          throw err;
        }
      );
  }

  onDateRangeSelected(dateRange: any) {
    this.pageId = 1;
    this.page = 1;
    this.offset = 0;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let strStart = this.dateInMs.toString();
    sessionStorage.setItem('filterDateSanctionStart', strStart);
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    let strEnd = this.endDateInMs.toString();
    sessionStorage.setItem('filterDateSanctionEnd', strEnd);
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      let dateType = 'dateRange';
      this.showSelectedDate = true;
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getUsersFilterDate('', this.roleId, 0, 10, this.dateInMs, this.endDateInMs, dateType)
        .subscribe((res) => {
          console.log(res);
          if (res && res.result && res.result.resultData) {
            if (res && res.result && res.result.resultData) {
              this.allUsers = res.result.resultData ? res.result.resultData : '';
              this.setCheckBoxesStatuses(this.allUsers);
              this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
              this.totalPage = Math.ceil(this.totalCount / 10);
            }
          } else {
            // this.allUsers = this.getEmptyArray()
            this.allUsersNew = [];
            this.closeButtonClick();
            this.snackbar.open('No Applicants found. The Filter is not Applied', 'OK', {
              duration: 4000,
            });
          }
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }

  // submitDates() {
  //   if(this.firstDate.nativeElement.value <= this.maxDate && this.firstDate.nativeElement.value >= '2022-01'  ){
  //   this.showSelectedDate = true;
  //   console.log(this.firstDate.nativeElement.value);
  //   let selected = this.firstDate.nativeElement.value;
  //   var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  //   var another = months[+selected.split('-')[1] - 1];
  //   this.selectedDate = another + ', ' + selected.split('-')[0];
  //   let filterDate = this.firstDate.nativeElement.value + '-01';
  //   sessionStorage.setItem('filterDateSanction', filterDate)
  //   let date = new Date(filterDate);
  //   let dateInMs = date.getTime();

  //   this.customer.getUsersFilterDate("", this.roleId, 0, 10, dateInMs).subscribe(res => {
  //     console.log(res);
  //     if(res && res.result && res.result.resultData){
  //       if(res && res.result && res.result.resultData){
  //         this.allUsers = res.result.resultData?res.result.resultData:"";
  //         this.totalCount = res && res.result && res.result.count?res.result.count:0;
  //         this.totalPage = Math.ceil(this.totalCount / 10);
  //       }
  //     } else {
  //       // this.allUsers = this.getEmptyArray()
  //       this.closeButtonClick()
  //       this.snackbar.open("No Applicants found. The Filter is not Applied",'OK', {duration:4000})
  //     }
  //   })
  // }else{
  //   this.snackbar.open("Please enter the valid date",'OK', {duration:4000})
  // }
  // }

  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateSanctionStart');
    sessionStorage.removeItem('filterDateSanctionEnd');
    sessionStorage.removeItem('filterDateSanction');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }

  updateCustId(user, idx) {
    if(user.journey_source != 'web'){
      this.snackbar.open(`Customer ID cannot be updated for ${user.journey_source} journey`, 'OK', { duration: 3000 });
      return
    }
    
    if (this.formArr.at(idx).get('customerId').status == 'INVALID') {
      this.snackbar.open(`Invalid ID`, 'OK', { duration: 3000 });
      return;
    }
    let controlValue = this.formArr.at(idx).get('customerId').value;
    this.custIds.forEach((val) => console.log(val));
    this.freshAuthService.updateCustId(controlValue, user.id).subscribe((resp) => {
      console.log(resp);
      if (resp && resp.success) {
        user.custId = controlValue;
        user.acc_no = resp.acc_no;
        this.updatedUser = user;
        this.openModal(user);
        this.generateForms(user.id);
        // this.snackbar.open('Customer ID updated Successfully','OK',{duration:3000})
      } else {
        if (resp.message == 'Failure to update as custId not found in CBS') {
          this.openErrorMessageDialog(
            'The entered Customer ID is Not Found in CBS.',
            'Please enter a valid Customer ID.'
          );
        } else if (resp.status == 'F') {
          this.openErrorMessageDialog(
            'Customer id has outstanding KCC Loan',
            'Failed to update as custId as ERR005.'
          );
        } else if (resp.message == 'Failed in Aadhaar No Match') {
          this.openErrorMessageDialog('Failed to update custId as Aadhar number mismatch', '');
        } else {
          this.snackbar.open(`Failed to update ${resp.message}`, 'OK', { duration: 3000 });
        }
      }
    });
  }

  generateForms(id) {
    forkJoin([
      this.freshAuthService.generateReferenceID(id, 'la'),
      this.freshAuthService.generateReferenceID(id, 'hp'),
      this.freshAuthService.generateReferenceID(id, 'dc'),
      this.freshAuthService.generateReferenceID(id, 'it'),
      this.freshAuthService.generateReferenceID(id, 'nt'),
      this.freshAuthService.generateReferenceID(id, 'sl'),
      this.freshAuthService.generateReferenceID(id, 'ut'),
      this.freshAuthService.generateReferenceID(id, 'ct'),
      this.freshAuthService.generateReferenceID(id, 'dp'),
      this.freshAuthService.generateReferenceID(id, 'dm'),
    ]).subscribe(
      ([
        response1,
        response2,
        response3,
        response4,
        response5,
        response6,
        response7,
        response8,
        response9,
        response10,
      ]) => {
        console.log(response1, 'response from 1');
        console.log(response2, 'response from 2');
        console.log(response3, 'response from 3');
        console.log(response4, 'response from 4');
        console.log(response5, 'response from 5');
        console.log(response6, 'response from 6');
        console.log(response7, 'response from 7');
        console.log(response8, 'response from 8');
        console.log(response9, 'response from 9');
        console.log(response9, 'response from 10');
        // if (response1 && response1.data && response1.data.referenceId) {
        //   sessionStorage.setItem("loanAppRefID", response1.data.referenceId);
        // }
        // if (response2 && response2.data && response2.data.referenceId) {
        //   sessionStorage.setItem("hypoRefID", response2.data.referenceId);
        // }
        // if (response3 && response3.data && response3.data.referenceId) {
        //   sessionStorage.setItem("declarationRefID", response3.data.referenceId);
        // }
        // if (response4 && response4.data && response4.data.referenceId) {
        //   sessionStorage.setItem("interestRefID", response4.data.referenceId);
        // }
        // if (response5 && response5.data && response5.data.referenceId) {
        //   sessionStorage.setItem("negativeRefID", response5.data.referenceId);
        // }
        // if (response6 && response6.data && response6.data.referenceId) {
        //   sessionStorage.setItem(
        //     "sanctionLetterRefID",
        //     response6.data.referenceId
        //   );
        // }
        // if (response7 && response7.data && response7.data.referenceId) {
        //   sessionStorage.setItem("undertakingRefID", response7.data.referenceId);
        // }
        // if (response8 && response8.data && response8.data.referenceId) {
        //   sessionStorage.setItem("continuityRefID", response8.data.referenceId);
        // }
        // if (response9 && response9.data && response9.data.referenceId) {
        //   sessionStorage.setItem("DPNRefID", response9.data.referenceId);
        // }
        // if (response10 && response10.data && response10.data.referenceId) {
        //   sessionStorage.setItem("demandRefID", response10.data.referenceId);
        // }
        // this.updateDocsData();
        // this.callName();
        // this.showSpinnerWithMessage = false;
      },
      (error) => {
        console.log(error);
        // this.showSpinnerWithMessage = false;
      }
    );
  }
  checkUpdateCustIdDisabled(i, user) {
    return user.custId
      ? true
      : this.formArr.at(i).get('customerId').status == 'INVALID'
        ? true
        : user.kyc_date
          ? true
          : false;
  }
  createLoan(user, idx?) {
    console.log(user);

    const applicantId = user.id;
    this.baseapi.createLoan(user.id).subscribe((resp) => {
      console.log(resp);
      if (resp && resp.success) {
        user.loanAccountNumber = resp.loanAccountNumber;
        if (idx != null && this.formArr.at(idx)) {
          this.formArr.at(idx).get('customerId').disable();
        }
        this.updatedUser = user;
        this.createLoanModal(user);
        this.snackbar.open('Loan Created Successfully', 'OK', { duration: 3000 });
      } else {
        this.snackbar.open(`resp.message`, 'OK', { duration: 3000 });
      }
    });
  }

  openModal(user: any) {
    this.ediTModaluser = user;
    this.showCustDetailsPopup = true;
  }

  createLoanModal(user: any) {
    this.showLoanCreatedPopup = true;
  }

  // Modal for KYC Compliance done checkbox
  openModal2(event, user) {
    event.preventDefault();
    this.kycModaluser = user;
    this.showKycConfirmPopup = true;
  }
  // Modal for KYC Compliance done checkbox

  kycChange() {
    let body = {
      appId: this.kycModaluser.id,
    };
    this.freshAuthService.updateKycCompliance(body);
    this.freshAuthService.updateKycCompliance(body).subscribe((resp) => {
      console.log(resp);
      this.kycModaluser.kyc_date = true;
      this.closeConfirmModal();
    });
  }
  prevDef(event) {
    event.preventDefault();
  }

  closeConfirmModal() {
    this.showKycConfirmPopup = false;
  }
  closeLoanDocExexcutedModal() {
    this.showDocExecutedPopup = false;
  }
  closeUpdateModal() {
    this.showCustDetailsPopup = false;
  }
  closeDownloadDocModal() {
    // this.downloadDocModalRef.close();
    this.showDownloadDocsModal = !this.showDownloadDocsModal;
  }
  close() {
    this.showLoanCreatedPopup = false;
  }

  //Modal for Loan Documents Executed checkbox
  openModal3(event, user, idx) {
    event.preventDefault();
    this.docModalData['user'] = user;
    this.docModalData['index'] = idx;
    this.showDocExecutedPopup = true;
  }
  //Modal for Loan Documents Executed checkbox

  openModal6(event, user) {
    event.preventDefault();
    this.lienModaluser = user;
    this.showLienConfirmPopup = true;
  }

  closeLienModal() {
    this.showLienConfirmPopup = false;
  }

  lienChange() {
    let body = {
      appId: this.lienModaluser.id,
    };
    this.freshAuthService.updateCropLien(body).subscribe((resp) => {
      console.log(resp);
      this.lienModaluser.crop_lien_date = true;
      this.closeLienModal();
    }, (err) => {
      this.closeLienModal();
      this.snackbar.open("Failed to submit details", "OK", { duration: 3000 });
    });
  }

  docChange() {
    this.documentDate = new Date(this.documentDateString);
    let body = {
      appId: this.docModalData['user'].id,
      date: this.documentDate.getTime(),
    };
    console.log(body);

    this.freshAuthService.LoanExecutedDate(body).subscribe((resp) => {
      console.log(resp);

      this.docModalData['user'].lde_date = new Date(this.documentDate);
      this.closeLoanDocExexcutedModal();
    });
  }

  // getDocs(user) {
  //   const applicantId = user.id;
  //   this.downloadForms = [];
  //   this.loading = true;
  //   this.baseapi.getDocs(user.id).subscribe((resp) => {
  //     this.loading = false;
  //     if (resp.result) {
  //       this.downloadForms = resp.result.filter((form) => form.label != 'dm');
  //       this.downloadForms.forEach((form) => (form.isChecked = false));
  //       this.openModal4(user);
  //     }
  //     console.log(resp);
  //   });
  // }

  //Modal which comes after clicking download doc button
  openModal4(user: any) {
    // this.downloadDocModalRef = this.modalService.open(this.downloadModal);
    this.showDownloadDocsModal = true;
    console.log(user);
  }
  //Modal which comes after clicking download doc button

  openModal5(user: any) {
    this.showLoanCreatedPopup = false;
    this.showFinalPopup = true;
    this.getData();
  }

  // selectAllDownloadForms(event: any) {
  //   if (event.target.checked) {
  //     this.downloadForms.forEach((form) => (form.isChecked = true));
  //   } else {
  //     this.downloadForms.forEach((form) => (form.isChecked = false));
  //   }
  // }

  selectAllDownloadForms(event: any) {
    if (event.target.checked) {
      this.downloadForms.forEach((form) => (form.isChecked = true));
      if(this.isCoLogin()){
        this.handleCheckRef();
      }
      this.wantAccWiseBreDownloaded = true;
    } else {
      this.downloadForms.forEach((form) => (form.isChecked = false));
      if(this.isCoLogin()){
        this.handleCheckRef();
      }
      this.wantAccWiseBreDownloaded = false;
    }
  }

  private handleCheckRef() {
    // console.log(this.checkRef.nativeElement)
    // const checkbox = this.checkRef.nativeElement;
    const checkbox =document.getElementById('uniqueCheckboxDisbursed') as HTMLInputElement; 
    console.log(checkbox)
    checkbox.checked = !checkbox.checked;
  }

  // downloadMyForms() {
  //   this.downloadForms.forEach((form) => {
  //     if (form.isChecked) {
  //       this.downloadLink(form);
  //     }
  //   });
  // }

  downloadLink(form: any) {
    const { link, label } = form;
    const linkSource = link;
    const downloadLink = document.createElement('a');
    const fileName = `${label}.pdf`;
    console.log(label);

    downloadLink.href = `${this.kccNewUat}/static/${linkSource}`;
    console.log(linkSource);

    this.https.get(downloadLink.href, { responseType: 'arraybuffer' }).subscribe(
      (pdf) => {
        const blob = new Blob([pdf], { type: 'application/pdf' });
        const fileName = `${label}.pdf`;
        saveAs(blob, fileName);
      },
      (err) => {
        console.log('err->', err);
      }
    );
  }

  openErrorMessageDialog(content1: string, content2: string) {
    const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
      width: 'auto',
      height: 'auto',
      data: {
        content1: content1,
        content2: content2,
        button1Text: 'OK',
      },
    });
  }

  isCoLogin() {
    if (this.roleId === 1) {
      return true;
    }
    return false;
  }

  async applyFilter(filter: string = '', offset: number = 0, pageId: number = 1, page: number = 1) {
    this.pageId = pageId;
    this.page = page;
    this.offset = offset;
    this.loading = true;
    this.showNtbDataTable = true;
    const formData = this.advancedFilterService.getFilterData();
    formData.filter = filter;
    formData.offset = offset;
    this.showOrHideTableColumns();
    await this.getCheckBoxes();
    try {
      this.freshAuthService.getSanctioned(formData).subscribe(
        (response) => {
          this.noUserFound = '';
          this.allUsers = response && response.resultData ? response.resultData : [];
          this.setCheckBoxesStatuses(this.allUsers);
          if (!this.allUsers.length) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.formArr.clear();
            this.allUsers.forEach((user) => {
              this.formArr.push(this.initRows(user));
              this.showFinalPopup = false;
            });
          }
          this.totalCount = response && response.count ? response.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.loading = false;
        },
        () => {
          this.noUserFound = 'Customer data not found';
          this.loading = false;
          this.totalCount = 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        }
      );
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.loading = false;
      this.totalCount = 0;
      this.totalPage = Math.ceil(this.totalCount / 10);
    }
  }

  createCifId(appId, i) {
    this.loading = true;
    this.freshAuthService.createCifId(appId).subscribe(
      (resp) => {
        this.loading = false;
        if (resp && resp.success) {
          this.snackbar.open(constants.CIF_ID_CREATED, "OK", { duration: 5000 })
          this.allUsers[i].custId = resp.cifid;
        } else {
          this.snackbar.open(constants.CIF_CREATE_FAILED, "OK", { duration: 5000 })
        }
      }, 
      (err) => {
        this.loading = false;
        this.snackbar.open(constants.CIF_CREATE_FAILED, "OK", { duration: 5000 })
    })

  }

  getDocs(user) {
    const applicantId = user.id;
    this.applicantId = user.id;
    this.downloadForms = [];
    this.loading = true;
    this.baseapi.getDocs(user.id).subscribe((resp) => {

      this.loading = false;
      if (resp.result && resp.result.length) {

        this.downloadForms = resp.result.filter((form) => form.label != 'dm');
        this.downloadForms.forEach((form) => (form.isChecked = false));
        let myArray = ["Loan Application Form", "Sanction Letter", "Digital Process Note",
          "Digitally Signed Document", "CIC Report", "Charge Khasra PDF 1", "Charge Khasra PDF 3"];

        const reorderedPdfArray = myArray.map(label => this.downloadForms.find(item => item.label === label));
        console.log(reorderedPdfArray)
        // const filteredArray = reorderedPdfArray.find(item=>item!==undefined)
        this.downloadForms = reorderedPdfArray.filter(Boolean);
        console.log(this.downloadForms)
        this.openModal4(user);
      }
      else {
        this.loading = false;
        this.snackbar.open("No data found.", "OK", { duration: 3000 })
      }
      console.log(resp);
    }, (err) => {
      this.loading = false;
      this.snackbar.open("Something went wrong", "OK", { duration: 3000 })
    });
  }

  changeAccWiseBre(event: any) {
    if (event.target.checked) {
      this.wantAccWiseBreDownloaded = true;
    } else {
      this.wantAccWiseBreDownloaded = false;
    }
  }

  downloadMyForms() {
    this.downloadForms.forEach((form) => {
      if (form.isChecked) {
        this.downloadLink(form);
      }
    });
    if (this.wantAccWiseBreDownloaded && this.isCoLogin()) {
      this.freshAuthService.downloadPdfAccWise(this.applicantId).subscribe(
        (resp) => {
        if (resp && resp.success) {
          if (resp.filePath) {

            try{
              const base64String = resp.filePath; // Your Base64 string here

              // Create a Blob from the Base64 string
              const byteCharacters = atob(base64String);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: 'application/pdf' });
  
              // Create a URL for the Blob
              const blobUrl = URL.createObjectURL(blob);
  
              // Create a link and trigger download
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = 'KCC-bre-checklist.pdf';// Filename when downloaded
              document.body.appendChild(link);
              link.click();
  
              // Clean up: Remove the link and revoke the Blob URL
              document.body.removeChild(link);
              URL.revokeObjectURL(blobUrl);
            }catch(err){
              this.snackbar.open("Unable to download Accountwise BRE report","OK",{duration:3000})
            }
            

          }else{
            this.snackbar.open("Unable to download Accountwise BRE report","OK",{duration:3000})
          }
        } else {
          this.snackbar.open("Unable to download Accountwise BRE report","OK",{duration:3000})
        }
      },(err)=>{
        this.snackbar.open("Accountwise BRE report download failed","OK",{duration:3000})
      })
    }
  }

  showOrHideTableColumns() {
    const stateCode = (sessionStorage.getItem('stateCode') || '').toLowerCase();
    this.isRJorGJ = constants.STATES.RJ.POSSIBILITIES.includes(stateCode) ||
      constants.STATES.GJ.POSSIBILITIES.includes(stateCode);
    this.showChecksColumn = true;
    this.showDownloadUploadColumn = true;
    this.showSanctionedDocuments = true;
  }
}



